export default __webpack_public_path__ + "static/media/Ballroll_00236.03f12631.png";